import Msig from "./msig";

export default Msig;
